import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'myabvv-personal-information-contribution',
    templateUrl: './personal-information-contribution.component.html',
    standalone: true,
    imports: [TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonalInformationContributionComponent implements OnInit {
  @Input() central: string;
  @Input() region: string;
  @Input() subRegion: string;
  @Input() lastMonthOfContribution: string;

  constructor() {}

  ngOnInit() {}
}
